angular.module('picmonicng').service('PusherService', [
  '$rootScope',
  function ($rootScope) {
    var self = this;

    self._pusher = null;

    self.channel = null;

    self.members = [];

    self.subscribe = function (channel) {
      self._pusher = new Pusher(PUSHER_KEY, { authEndpoint: '/api/v2/pusher' });
      self.channel = self._pusher.subscribe(channel);

      return self;
    };

    self.unsubscribe = function () {
      self.channel.unsubscribe();

      return self;
    };

    self.success = function (callback) {
      self.channel.bind('pusher:subscription_succeeded', function (data) {
        $rootScope.$apply(function () {
          self.updateMembers();
          callback(data);
        });
      });

      return self;
    };

    self.memberAdded = function (callback) {
      self.channel.bind('pusher:member_added', function (data) {
        $rootScope.$apply(function () {
          self.updateMembers();
          callback(data);
        });
      });

      return self;
    };

    self.memberRemoved = function (callback) {
      self.channel.bind('pusher:member_removed', function (data) {
        $rootScope.$apply(function () {
          self.updateMembers();
          callback(data);
        });
      });

      return self;
    };

    self.updateMembers = function () {
      var members = [];
      for (a in self.channel.members.members) {
        members.push(self.channel.members.members[a]);
      }

      self.members = members;
    };
  },
]);
